/**
 * GAPS-6 (2026-10-18) — one dock for the two floating schedule panels.
 *
 * ScheduleConflictPanel (`fixed bottom-4 left-4`) and RolloverDecisionPanel (`fixed bottom-4 right-4`) were each
 * `min(…, 100vw − 2rem)` wide: at phone width (393 px) both are 361 px, so when both showed they sat on top of each
 * other and one hid the other's button. Both now portal into this dock: stacked (column, right-aligned) below `lg`,
 * side by side (conflict left, decision right) from `lg` up. The dock itself ignores the pointer so the board under
 * its empty area stays usable; each panel opts back in.
 *
 * WS-BROWSER (2026-10-18, real browser at 393 / 820 / 1180 / 1440 px): pinned to `bottom-4` the dock sat UNDER the
 * app's floating buttons — "Report an Issue" (ReportIssueButton, default top = innerHeight − 80 px, so it covers
 * the bottom 80 px on the left) and the tutorial Help button (HelpMenu, `fixed bottom-4 right-4`, 56 px on a phone →
 * the bottom 72 px on the right, z 10000). At 393 px they covered the decision panel's toggle, which could not be
 * opened. The dock now starts above them (SCHEDULE_DOCK_BOTTOM_CLEARANCE_PX); the expanded lists are capped lower
 * below `lg` so the taller stack still clears the top bar on a phone.
 *
 * OCT20D-F1: the technician's departure-review notice (TimerReviewHost) joins the dock too (order 0), so it sits above
 * the rail instead of on top of Report an Issue; on a SHORT viewport (≤ 500 px tall, a landscape phone) index.css caps
 * the expanded lists lower still, because both lists expanded ran the dock off the top of a 375 px viewport and put the
 * first panel's collapse toggle out of reach.
 */
export const SCHEDULE_DOCK_ID = 'schedule-panel-dock';
/** Bottom offset of the dock: above the floating Report-an-Issue rail (60 px since OCT20C-F1; was 80) and Help (72 px) buttons, plus a gap. */
export const SCHEDULE_DOCK_BOTTOM_CLEARANCE_PX = 88;
export const SCHEDULE_DOCK_CLASS =
  'pointer-events-none fixed inset-x-4 bottom-[5.5rem] mb-safe-bottom z-40 flex flex-col items-end gap-2 lg:flex-row lg:items-end lg:justify-between';

export function getScheduleDock(): HTMLElement {
  let el = document.getElementById(SCHEDULE_DOCK_ID);
  if (!el) {
    el = document.createElement('div');
    el.id = SCHEDULE_DOCK_ID;
    el.setAttribute('data-testid', SCHEDULE_DOCK_ID);
    // OCT20C-F1: a floating control — its height joins the app's bottom reserve (floatingControlsReserve.ts).
    el.setAttribute('data-floating-control', 'schedule-dock');
    el.className = SCHEDULE_DOCK_CLASS;
    document.body.appendChild(el);
  }
  return el;
}
